
/* ARC pool injected by Liquid */

window.SECO_INIT = function () {
/* SECO — hover-arc engine + staggered entrance reveal
   The arc tiles hold a real Seedance turntable frame sequence. At rest we show
   frame 0 (flat left profile). On hover-intent we step forward to the last frame
   (~45 degrees, three-quarter front-left) and back again on leave. The camera
   never moves: the lift and scale come from CSS, the rotation from the frames.
   Same motion the Bell Flight products menu uses. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FRAME_MS = 26;            // one tempo for every vehicle, so they all turn together

  /* ---------- staggered entrance ---------- */
  var revealables = [].slice.call(document.querySelectorAll('.rv'));
  if (reduce || !('IntersectionObserver' in window)) {
    revealables.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var group = el.closest('[data-stagger]');
        var i = 0;
        if (group) i = [].indexOf.call(group.querySelectorAll('.rv'), el);
        el.style.animationDelay = Math.min(i, 12) * 70 + 'ms';
        el.classList.add('in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealables.forEach(function (el) { io.observe(el); });
  }

  /* ---------- hover arc ---------- */
  function Arc(tile) {
    var img = tile.querySelector('img');
    var prefix = tile.getAttribute('data-arc');
    var count = parseInt(tile.getAttribute('data-frames'), 10) || 0;
    if (!img || !prefix || count < 2) return;

    var frames = [], loaded = false, cur = 0, target = 0, raf = null;
    var last = count - 1;

    /* frame URLs come either from the assets folder or, in the single-file
       preview build, from an inlined window.ARC pool of data URLs */
    var pool = (window.ARC && window.ARC[prefix]) || null;
    function frameSrc(i) {
      return pool ? pool[i] : prefix + String(i).padStart(2, '0') + '.webp';
    }

    function preload() {
      if (loaded) return;
      loaded = true;
      for (var i = 0; i < count; i++) {
        var im = new Image();
        im.decoding = 'async';
        im.src = frameSrc(i);
        frames.push(im);
      }
    }

    /* Advance one frame at a time. If the next frame has not decoded yet we WAIT
       for it rather than skipping — a skipped frame reads as a blank tile on the
       first cold hover, which is worse than a fractionally slower first pass. */
    var busy = false;
    function step() {
      raf = null;
      if (busy || cur === target) return;
      var next = cur + (cur < target ? 1 : -1);
      var f = frames[next];
      function commit() {
        busy = false;
        cur = next;
        if (f.naturalWidth) img.src = f.src;
        raf = requestAnimationFrame(function () { setTimeout(step, FRAME_MS); });
      }
      if (f.complete) { commit(); return; }
      busy = true;
      f.addEventListener('load', commit, { once: true });
      f.addEventListener('error', commit, { once: true });
    }

    function to(n) {
      target = Math.max(0, Math.min(last, n));
      if (raf === null && !busy) step();
    }

    if (reduce) return;                 // rest state only

    tile.addEventListener('pointerenter', function () { preload(); to(last); });
    tile.addEventListener('focusin', function () { preload(); to(last); });
    tile.addEventListener('pointerleave', function () { to(0); });
    tile.addEventListener('focusout', function () { to(0); });

    /* touch: play the arc once when the tile is well into view */
    if (window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
      var seen = false;
      var tio = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting || seen) return;
          seen = true; preload();
          setTimeout(function () { to(last); setTimeout(function () { to(0); }, 1500); }, 250);
          tio.unobserve(tile);
        });
      }, { threshold: 0.55 });
      tio.observe(tile);
    }
  }
  [].forEach.call(document.querySelectorAll('[data-arc]'), Arc);

  /* ---------- hero video ----------
     The 1920 pair is in the markup so it plays without JS. On a narrow viewport
     or with data saver on, swap to the 1280 pair — a full-bleed hero is heavily
     scrimmed and cropped hard on a phone, so the extra pixels are invisible and
     the bytes are not. prefers-reduced-motion holds it on frame 0, which is the
     poster frame, so the hero still reads as intended. */
  var hero = document.getElementById('heroVid');
  if (hero) {
    if (reduce) {
      hero.removeAttribute('autoplay');
      hero.pause();
      try { hero.currentTime = 0; } catch (e) {}
    } else {
      var conn = navigator.connection || {};
      var light = window.matchMedia('(max-width: 900px)').matches ||
                  conn.saveData === true ||
                  /^(slow-)?2g$/.test(conn.effectiveType || '');
      if (light) {
        [].forEach.call(hero.querySelectorAll('source'), function (src) {
          src.src = src.src.replace(/hero\.(webm|mp4)$/, 'hero-sm.$1');
        });
        hero.load();
      }
      var play = hero.play();
      if (play && play.catch) play.catch(function () { /* autoplay blocked: poster stands in */ });
    }
  }

  /* ---------- Parts dropdown panes ----------
     Thirteen collections down the left, one pane of sub-categories to the right.
     Pointer selects on hover so it feels like the rest of the header; keyboard
     selects on focus, and arrow keys walk the rail as a tablist should. */
  var rail = document.querySelector('.mega__rail');
  if (rail) {
    var tabs = [].slice.call(rail.querySelectorAll('.mega__c'));
    var panes = [].slice.call(document.querySelectorAll('.mega__pane'));
    var panebox = document.querySelector('.mega__panes');
    var narrow = window.matchMedia('(max-width: 860px)');

    /* On a phone the dropdown is a stacked list, so a pane parked at the bottom
       would sit thirteen collections below the thing you tapped. Move the open
       pane directly under its own button instead — the same shape as the
       accordion on the live store. On a wide screen the panes live in the right
       column, so put them back. */
    function place(key) {
      if (narrow.matches) {
        panes.forEach(function (p) {
          if (p.getAttribute('data-pane') !== key) return;
          var btn = rail.querySelector('.mega__c[data-pane="' + key + '"]');
          if (btn && p.previousElementSibling !== btn) btn.insertAdjacentElement('afterend', p);
        });
      } else {
        panes.forEach(function (p) {
          if (p.parentElement !== panebox) panebox.appendChild(p);
        });
      }
    }

    function show(key) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-pane') === key;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panes.forEach(function (p) {
        p.classList.toggle('is-on', p.getAttribute('data-pane') === key);
      });
      place(key);
    }

    if (narrow.addEventListener) {
      narrow.addEventListener('change', function () {
        var on = rail.querySelector('.mega__c.is-on');
        place(on ? on.getAttribute('data-pane') : null);
      });
    }
    tabs.forEach(function (t, i) {
      var key = t.getAttribute('data-pane');
      t.addEventListener('pointerenter', function () { show(key); });
      t.addEventListener('focus', function () { show(key); });
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var destinations = {
          '01': '/collections/hmmwv-parts',
          '02': '/collections/hummer-h1-parts',
          '03': '/collections/m113-parts-for-sale',
          '04': '/collections/m151-parts',
          '05': '/collections/2-5-ton-parts',
          '06': '/collections/5-ton-m939-m900-series',
          '07': '/collections/mrap-spare-parts',
          '08': '/collections/m1070-het-spare-parts',
          '09': '/collections/hemtt-m977',
          '10': '/collections/m1161-m1163-growler-parts-lsv-for-sale',
          '11': '/collections/5-ton-m800-series-parts',
          '12': '/collections/lmtv-fmtv-parts',
          '13': '/collections/trucks-equipment'
        };
        if (destinations[key]) { window.location.assign(destinations[key]); return; }
        show(key);
      });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowDown' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        tabs[(i + d + tabs.length) % tabs.length].focus();
      });
    });
  }

  /* ---------- mobile nav ---------- */
  var tgl = document.querySelector('.navtoggle');
  var nav = document.querySelector('.nav');
  if (tgl && nav) {
    tgl.addEventListener('click', function () {
      var open = nav.classList.toggle('open');
      tgl.setAttribute('aria-expanded', open ? 'true' : 'false');
      tgl.textContent = open ? 'Close' : 'Menu';
    });
  }
  [].forEach.call(document.querySelectorAll('.has-mega > a'), function (a) {
    a.addEventListener('click', function (e) {
      if (window.matchMedia('(max-width: 860px)').matches) {
        e.preventDefault();
        a.parentElement.classList.toggle('open');
      }
    });
  });
})();

};

/* Multi-page build: no router. Initialise once per server-rendered page. */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () { window.SECO_INIT(); });
} else { window.SECO_INIT(); }
